import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-new-exam-codes',
  templateUrl: './new-exam-codes.component.html',
  styleUrls: ['./new-exam-codes.component.scss']
})
export class NewExamCodesComponent implements OnInit {
  NewEmCdForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  NewCdArrayTable: [];
  NewCdArray: FormArray;
  table = false;
  length: any;
  CourseList: any;
  filteredListCourse: any;
  CourseCode: any;
  success: any;
  error: any;
  userPermission: any;
  utp: string;
  newCodeUpdate = true;
  constructor(private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private fb: FormBuilder,   public router: Router,
    private route: ActivatedRoute, private spinner:NgxSpinnerService, ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      // if(element.PageName == 'Faculty' && element.PCreate == false)
      // {
      //     this.FacultyCreate = false;  
      // }
      if(element.PageName == 'New-Exam-Code' && element.PUpdate == false)
      {
          this.newCodeUpdate = false;  
      }   
      // if(element.PageName == 'Faculty' && element.PDelete == false)
      // {
      //     this.FacultyDelete = false;  
      // } 
    });
  }
    window.scroll(0, 0);
    this.table = false;
    this.NewEmCdForm = this.fb.group({
      NeEmId: new FormControl(''),
      NeEmCode: new FormControl (''),
      NeNewCode: new FormControl (''),     
      NewCdArray: new FormArray([]),    
    });
    this.fetchCourseCode();
  }
  
  fetchCourseCode() {
    const payload = {};
    this.umsService.getCourse(payload).subscribe((res) => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      } else {
      }
    });
  }

  getNewCdArrayControls() {
    return (this.NewEmCdForm.get('NewCdArray') as FormArray).controls;
  }

  getNewEmCode(e){
    const payload = {};
    payload['CoCode'] = e;
    this.umsService.getNewEmCode(payload).subscribe((res) => {
      this.length = res.data.length;
      if(res.data.length > 0){
        // this.prepopulation(res.data)
        this.NewCdArrayTable = res.data;
        // this.NewCdArray.clear();
        this.NewCdArrayTable.forEach(element => {
          this.addNewRowPrepopulate(element);
        });
      }else{
        this.addNewRow();
      }
    });
  }

  addNewRowPrepopulate(e){
    const creds = this.NewEmCdForm.controls.NewCdArray as FormArray;
    creds.push(
      this.fb.group({
        NeEmId: new FormControl (e.EmId),
        NeEmCode: new FormControl (e.EmCode),
        NeNewCode: new FormControl (e.NeNewCode),  
      })
    );
  }
  addNewRow() {
   
    const creds = this.NewEmCdForm.controls.NewCdArray as FormArray;
    creds.push(
      this.fb.group({
      NeEmId: new FormControl (''),
      NeEmCode: new FormControl (''),
      NeNewCode: new FormControl (''), 
      })
    );
  }

  getTable(e){
    this.table = true;
    this.CourseCode = e;
    this.getNewEmCode(e)
  }
  
  update(){
    if (this.NewEmCdForm.invalid) {
      this.NewEmCdForm.get('NeEmCode').markAsTouched();
      this.NewEmCdForm.get('NeNewCode').markAsTouched();
      return;
    } else {
        this.UpdateExamSem();
    }
  }

  UpdateExamSem(){
    let success           
    // this.spinner.show();
    this.submitpayload = this.NewEmCdForm.value;
    let arr = [];
    arr = this.submitpayload.NewCdArray
    arr.forEach(element => {
      this.umsService.updateNewEmCode(element).subscribe(res => {
        // this.spinner.hide();
        if (res.status) {
          success = res.status;
          // let  data = {}
          // data['message'] = "Changes Saved"
          // data['title'] = 'Update'
          // data['icon'] = 'fas fa-check'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          
        } else {
          success = false;
          this.error = res.message;
          // let  data = {}
          // data['message'] = res.message
          // data['title'] = 'Information'
          // data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      });
    });

    if(success == true){
      let  data = {}
      data['message'] = "Changes Saved"
      data['title'] = 'Update'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    else if(success == false){
      let  data = {}
          data['message'] = this.error
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    
  }

  
}
